import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';

import {useLocalesMgr} from 'coreHooks';

import Content from 'brand/app/contentful/components/Content';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import Typography from 'brandComponents/Typography';

import {IPersonalizedContent} from './IPersonalizedContent';

import styles from './PersonalizedContent.module.scss';

const PersonalizedContent = ({
	initialData,
	slug,
	message,
	cta,
}: IPersonalizedContent) => {
	const {managerRepository} = useGeneralProvider();
	const [data, setData] = useState(initialData);
	const cmsProvider = managerRepository.getContentMgr().getCMSProvider();
	const localesMgr = useLocalesMgr();
	const intl = useIntl();
	const languageCode = localesMgr.getCurrentLocale().getLanguageCode();
	const countryCode = localesMgr.getCurrentLocale().getCountryCode();

	useEffect(() => {
		if (!initialData) {
			cmsProvider
				.getContent(
					'page',
					{
						variables: {
							slug: {en: slug},
							locale: languageCode,
						}
					},
					true,
				)
				.then((res) => setData(res));
		}
	}, [languageCode, countryCode]);

	return (
		<div className={styles['personalized-content__container']}>
			{message && (
				<Typography variant="h3" classNames={styles['personalized-content__container__message']}>
					{intl.formatMessage(message)}
				</Typography>
			)}
			{cta?.message && (
				<Button onClick={cta.onClick} variant={cta.variant || 'primary'}>
					{intl.formatMessage(cta.message)}
				</Button>
			)}
			{!!data && <Content data={data} />}
		</div>
	);
};

export default PersonalizedContent;
